import React from 'react';
import PropTypes from 'prop-types';
import { Column, Margin, Direction } from '@scotia/canvas-react';

export const ThreeColumnLayout = ({ renderCol1, renderCol2, renderCol3 }) => (
  <Direction
    type="row"
    style={{
      border: '1px solid #eee',
      borderLeft: 'none',
      borderRight: 'none',
      wordWrap: 'break-word'
    }}
  >
    <Column
      xs={6}
      sm={6}
      md={4}
      lg={4}
      style={{
        borderRight: '1px solid #eee',
        padding: '15px',
        wordWrap: 'break-word'
      }}
    >
      {typeof renderCol1 === 'function' && renderCol1()}
    </Column>
    <Column
      xs={6}
      sm={6}
      md={4}
      lg={4}
      style={{
        padding: '15px',
        wordWrap: 'break-word'
      }}
    >
      {typeof renderCol2 === 'function' && renderCol2()}
    </Column>
    <Column
      xs={12}
      sm={12}
      md={4}
      lg={4}
      style={{
        padding: '15px',
        borderLeft: '1px solid #eee'
      }}
    >
      {typeof renderCol3 === 'function' && renderCol3()}
    </Column>
  </Direction>
);
